module.exports = __webpack_public_path__ + "static/Springboard-52fef5b510ed632d22ecaa72a917f5e3.jpg";